export type PackageItem = {
    slug: string
    eyebrow: string
    name: string
    price: string
    image: string
    imageAlt: string
    description: string
}

export type PackagesQuote = {
    quote: string
    name: string
    image: string
}

/**
 * The inn's Ski & Stay package: discounted Killington and Pico lift tickets,
 * sold only with a room reservation. Prices are the published 2025–26 rates.
 */
export const packageItems: PackageItem[] = [
    {
        slug: 'non-peak-ski-and-stay',
        eyebrow: "Monday to Friday",
        name: "Non-Peak Ski & Stay",
        price: "$145 per lift ticket (2025–26)",
        image: '/images/greenbrier/slide-ski.jpg',
        imageAlt: "Skier in deep powder snow under a blue sky",
        description: "Add an adult Killington or Pico lift ticket to your room for $145, down from the $204 window price. Save 29%."
    },
    {
        slug: 'weekend-and-peak-ski-and-stay',
        eyebrow: "Weekends & peak days",
        name: "Weekend & Peak Ski & Stay",
        price: "$165 per lift ticket (2025–26)",
        image: '/images/greenbrier/slide-ski2.jpg',
        imageAlt: "Skier on a groomed run with ski trails on the mountain behind",
        description: "Any Saturday, Sunday or peak date: add an adult lift ticket to your room for $165 instead of $204. Save 20%."
    }
]

/** No published guest quote yet, so the quote band on the packages page stays hidden. */
export const packagesQuote: PackagesQuote | null = null
